import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers/rootReducer';

export default () => useSelector((state: RootState) => state.auth.user);
